








import {
  Vue,
  Component,
  Prop,
} from "@/shared/vuepack";
import { formatCurrency } from "@/shared/currency";
import { GChart } from "vue-google-charts";
import { useThemeStore } from "@/shared/store/theme";

@Component({
  components: {
    GChart
  }
})
export default class PocReimburseMeBarChart extends Vue {
  themeStore = useThemeStore();


  @Prop()
  cash: number;

  @Prop()
  unreimbursed: number;

  @Prop()
  width: number;

  @Prop()
  height: number;

  emptyColor = "#E6EAEE";

  get getChartOptions () {
    return {
      fontName: this.themeStore.fontFace,
      annotations: {
        stem: { color: "transparent" },
        highContrast: false,
        alwaysOutside: true,
        textStyle: {
          fontSize: 16,
          bold: true,
          color: this.themeStore.tertiaryColor
        }
      },
      chartArea: {
        top: 10,
        left: "5%",
        width: "90%",
        height: "85%",
      },
      height: this.height,
      legend: { position: "none" },
      bar: { groupWidth: "80%" },
      hAxis: {
        textStyle: {
          color: "#000",
          fontSize: 14,
          bold: false
        }
      },
      vAxis: {
        textPosition: "none",
        gridlines: {
          count: 1
        },
      },
      enableInteractivity: false,
    };
  }

  get chartData () {
    return [
      [
        "Item", "Amount",
        { role: "style" },
        { role: "annotation" }
      ],
      [
        "Cash Account", this.cash,
        `fill-color: ${this.emptyColor}; text-color: ${this.themeStore.tertiaryColor}`,
        `${formatCurrency(this.cash)}`
      ],
      [
        "Expenses Available for Withdrawal", this.unreimbursed,
        `fill-color: ${this.themeStore.primaryColor}; font-color: ${this.themeStore.tertiaryColor}`,
        `${formatCurrency(this.unreimbursed)}`
      ]
    ];
  }
}
